import type React from 'react';
import { useState } from 'react';
import type { Editor } from '@tiptap/react';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import { PyMuiIconButton, PyMuiMenu, PyMuiMenuItem } from 'components/editor/GridDndEditor/TiptapEditor/components/generalComponents';
import HyperlinkInput from 'components/editor/GridDndEditor/TiptapEditor/components/Link/HyperLinkInput';

type Props = { editor: Editor };

const LinkButton: React.FC<Props> = ({ editor }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpenMenu: React.MouseEventHandler<HTMLElement> = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <PyMuiIconButton attributeName="link" isMenuOpen={Boolean(anchorEl)} onClick={handleOpenMenu} isActive={editor.isActive('link')}>
        <InsertLinkIcon />
      </PyMuiIconButton>

      <PyMuiMenu
        testId="hyperlink-menu"
        id="select-hyperlink-menu"
        menuListProps="hyperlink-menu"
        anchorEl={anchorEl}
        isMenuOpen={Boolean(anchorEl)}
        handleClose={handleCloseMenu}
        direction="row"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        overrideShadow={false}
      >
        <PyMuiMenuItem
          key="hyperlink-menu-item"
          testId="hyperlink-menu-item"
          menuItem={<HyperlinkInput onClose={handleCloseMenu} editor={editor} />}
        />
      </PyMuiMenu>
    </>
  );
};

export default LinkButton;
